import React, { useState, useEffect, Fragment } from 'react';
import {
  Card,
  CardBody,
  Button,
  TabContent,
  TabPane,
  NavItem,
  Modal,
  ModalHeader,
  ModalFooter,
  ModalBody,
  Input,
  CardHeader,
  Nav,
} from 'reactstrap';
import { Separator } from '../../../../../../components/common/CustomBootstrap';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { AxiosAPI, getGroupID } from '../../../../../../helpers/AxiosAPI';
import { NavLink } from 'react-router-dom';
import classnames from 'classnames';
import '../../style/style.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope } from '@fortawesome/free-solid-svg-icons';
import { post_API_Send_Email } from '../../../../../../constants/APIs';
import { NotificationManager } from '../../../../../../components/common/react-notifications';


export default function StandaloneCodeSnippet({ integration, propertyId }) {
  const [activeTab, setActiveTab] = useState('directLink');
  const [showEmailBox, setShowEmailBox] = useState(false);
  const [developerEmail, setDeveloperEmail] = useState('');
  const [directLink, setDirectLink] = useState('');
  const [directLinkCopied, setDirectLinkCopied] = useState('');

  useEffect(() => {
    const gid = getGroupID();
    const iid = integration.id;
    const link = `${process.env.REACT_APP_SERVICE_URL}/gshp?iid=${integration.id}&gid=${getGroupID()}`;
    setDirectLink(link);
  }, []);


  const toggleAppMenu = (tab) => {
    setActiveTab(tab);
  };

  const SendEmail = () => {

    let data = {
      'groupId': getGroupID(), intregationId: integration.id,
      'Email': developerEmail, 'PropertyId': propertyId
    };
    AxiosAPI({
      method: 'post',
      url: `${post_API_Send_Email}`,
      data,
    })
      .then((res) => {
        NotificationManager.success(
          '',
          'Email sended successfully',
          2000,
          null,
          null,
          'success'
        );
      })
  };
  return (
    <Fragment>
      <CardHeader className="pl-0 pr-0">
        <Nav tabs className="card-header-tabs ml-0 mr-0 row ">
          <NavItem className="w-50 text-center col-md-12">

            <NavLink
              className={classnames({
                active: activeTab === 'directLink',
                'nav-link': true,
              })}
              onClick={() => {
                toggleAppMenu('directLink');
              }}
              to="#"
            >
              Standalone Guest Service Page
            </NavLink>
          </NavItem>
        </Nav>
      </CardHeader>
      <TabContent activeTab={activeTab} className="">
        <TabPane tabId="directLink" className="chat-app-tab-pane">
          <Card className="mb-4">
            <CardBody>
              <h6 className="text-center">Standalone Guest Service Page</h6>
              <Separator className="mb-3" />
              <div className="code-snippet">
                <span>
                  {process.env.REACT_APP_SERVICE_URL}/gshp?iid=
                  {integration.id}&amp;gid={getGroupID()}
                </span>
              </div>
              <div className="text-center">
                <CopyToClipboard
                  text={directLink}
                  onCopy={() => setDirectLinkCopied(true)}
                >
                  <Button
                    color="success"
                    size="xs"
                    style={{ marginTop: '10px' }}
                  >
                    Copy the URL
                  </Button>
                </CopyToClipboard>
                {directLinkCopied ? <div>Copied.</div> : null}
              </div>
            </CardBody>
          </Card>
        </TabPane>

      </TabContent>
      <Modal className='intregation-modal-content' style={{ borderRadius: '10px' }} isOpen={showEmailBox} toggle={() => setShowEmailBox(!showEmailBox)}>
        <ModalHeader toggle={() => setShowEmailBox(!showEmailBox)}>
          Your developer`s e-mail address:
        </ModalHeader>
        <ModalBody>
          <p>
            Your developer teammate will receive an e-mail containing the code
            and necessary instructions to implement it.
          </p >
          <p >
            <Input
              className='mt-2'
              style={{ borderRadius: '10px' }}
              type="text"
              name="email"
              value={developerEmail}
              placeholder="E-mail"
              onChange={(e) => setDeveloperEmail(e.target.value)}
            />
          </p>
        </ModalBody>
        <ModalFooter>
          <Button
            color="success"
            size="xs"
            style={{ marginTop: '10px', marginLeft: '20px' }}
            onClick={() => { SendEmail(); setDeveloperEmail(''); setShowEmailBox(!showEmailBox); }}
          >
            <FontAwesomeIcon icon={faEnvelope}></FontAwesomeIcon><span className='ml-2' >Send</span>
          </Button>
        </ModalFooter>
      </Modal>
    </Fragment>
  );
}
